import { Group } from '@Globals/SplitTests/types'

export const convertToGroup = (raw: any): Group => {
  switch (raw) {
    case false:
    case 'false':
    case 0:
    case '0':
    case 'a':
    case 'A':
      return 'a'
    case true:
    case 'true':
    case 1:
    case '1':
    case 'b':
    case 'B':
      return 'b'
    case 2:
    case '2':
    case 'c':
    case 'C':
      return 'c'
    case 3:
    case '3':
    case 'd':
    case 'D':
      return 'd'
    default:
      return 'unknown'
  }
}
